import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { StatusFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useStatusFilter = (model: StatusFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<StatusFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: StatusFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        jobStatuses:
          newModel?.jobStatuses && newModel.jobStatuses.length > 0
            ? newModel.jobStatuses
            : ['ANY'],
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const currentStatuses = model?.jobStatuses || [];
    const previousStatuses = previousModelReference.current?.jobStatuses || [];

    const hasChanged =
      currentStatuses.length !== previousStatuses.length ||
      currentStatuses.some(
        (status, index) => status !== previousStatuses[index]
      );

    if (hasChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};

